export default __webpack_public_path__ + "static/media/3stepweightloss_3@3x.b63df684.jpg";